import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";
import React from "react";
import Iconify from "../../components/iconify/Iconify";
import { formatCurrency } from "../../utils/currency";

export default function ItemVariantAddonSelection({
  selectedAddons,
  setSelectedAddons,
  itemAddons,
}) {
  // 1. Handle Card Click (Increment)
  const handleIncrement = (id) => {
    setSelectedAddons((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  // 2. Handle Minus Click (Decrement)
  const handleDecrement = (e, id) => {
    e.stopPropagation(); // Stop card click event
    setSelectedAddons((prev) => {
      const current = prev[id] || 0;
      if (current <= 1) {
        const newState = { ...prev };
        delete newState[id]; // Remove key if 0
        return newState;
      }
      return { ...prev, [id]: current - 1 };
    });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Choose Add-ons
      </Typography>

      <Grid container spacing={2}>
        {itemAddons.map((addon) => {
          const qty = selectedAddons[addon.product_addon_uid] || 0;
          const isSelected = qty > 0;

          return (
            <Grid item xs={6} sm={4} key={addon.id}>
              <Paper
                elevation={isSelected ? 3 : 0}
                variant="outlined"
                onClick={() => handleIncrement(addon.product_addon_uid)}
                sx={{
                  position: "relative",
                  p: 1.5,
                  height: 80, // Fixed height
                  cursor: "pointer",
                  display: "flex",
                  color: isSelected ? "primary.main" : "#000",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  transition: "all 0.1s ease-in-out",
                  userSelect: "none",
                  borderLeft: isSelected
                    ? "5px solid #2e7d32"
                    : "1px solid #ddd",
                  borderColor: isSelected ? "transparent" : "divider",
                  bgcolor: isSelected ? "action.hover" : "background.paper",
                  "&:active": { transform: "scale(0.98)" },
                }}
              >
                {/* 1. Badge Counter (Top Right) */}
                {isSelected && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      bgcolor: "#1976d2", // Blue badge
                      color: "white",
                      borderRadius: "50%",
                      width: 24,
                      height: 24,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      boxShadow: 2,
                      zIndex: 2,
                    }}
                  >
                    {qty}
                  </Box>
                )}

                {/* 2. Content (Name & Price) */}
                <Typography
                  variant="body2"
                  fontWeight={isSelected ? 600 : 400}
                  sx={{ lineHeight: 1.2 }}
                >
                  {addon.addon_name}
                </Typography>
                <Typography variant="caption" color="#000">
                  {formatCurrency(addon.price)}
                </Typography>

                {/* 3. Minus Button (Bottom Right) */}
                {isSelected && (
                  <IconButton
                    size="small"
                    onClick={(e) => handleDecrement(e, addon.product_addon_uid)}
                    sx={{
                      position: "absolute",
                      bottom: 2,
                      right: 2,
                      bgcolor: "#fff",
                      border: "1px solid #ddd",
                      width: 24,
                      height: 24,
                      p: 0,
                      "&:hover": { bgcolor: "#f5f5f5", color: "error.main" },
                    }}
                  >
                    <Iconify icon="mdi:minus" width={16} />
                  </IconButton>
                )}
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
